var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80763 0C3.95123 0 0 3.95123 0 8.80763C0 13.6643 3.95123 17.6153 8.80763 17.6153C13.6643 17.6153 17.6153 13.6643 17.6153 8.80763C17.6153 3.95123 13.6643 0 8.80763 0ZM8.80763 15.9893C4.84772 15.9893 1.62603 12.7676 1.62603 8.80767C1.62603 4.84776 4.84772 1.62603 8.80763 1.62603C12.7675 1.62603 15.9892 4.84772 15.9892 8.80763C15.9892 12.7675 12.7675 15.9893 8.80763 15.9893Z",
    fill: "#219EBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.762 18.6123L15.1007 13.951C14.7831 13.6334 14.2687 13.6334 13.9511 13.951C13.6335 14.2683 13.6335 14.7833 13.9511 15.1006L18.6124 19.7619C18.7712 19.9207 18.9791 20.0001 19.1872 20.0001C19.395 20.0001 19.6032 19.9207 19.762 19.7619C20.0796 19.4445 20.0796 18.9296 19.762 18.6123Z",
    fill: "#219EBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.0cc55433f04bd7a943b560c594edea55.svg";
export { ForwardRef as ReactComponent };